import { render, staticRenderFns } from "./DContainerLayout.vue?vue&type=template&id=398b9ca4&"
import script from "./DContainerLayout.vue?vue&type=script&lang=ts&"
export * from "./DContainerLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports